import { convertToCampaignServerContext } from './server-context-utils';
import { IsCopilotFraudRestrictedParams } from './types';

const urlPattern = /^\/cc\/FraudAppeal($|\/)/i;

export function isCopilotFraudRestricted(params: IsCopilotFraudRestrictedParams): boolean {
  const {
    location = window.location,
    logger,
    permissions,
    serverContext,
  } = params;

  if (permissions?.dynamic?.AdsCopilotFraudRestriction === true) {
    const campaignServerContext = convertToCampaignServerContext(serverContext);
    if (campaignServerContext) {
      const customerId = campaignServerContext.CurrentAccount?.AdvertiserCustomerID || campaignServerContext.CurrentCustomer?.Id;
      if (!customerId) {
        logger?.trace('isCopilotFraudRestricted: Customer ID is not set, restricting access');
        return true;
      }
    }

    // true if user is on a fraud appeal page
    const isFraudPage = urlPattern.test(location.pathname);
    if (isFraudPage) {
      logger?.trace('isCopilotFraudRestricted: User is on a fraud appeal page, restricting access');
    }
    return isFraudPage;
  }

  // pilot not enabled
  return false;
}
